namespace $.$$ {

	$mol_style_define( $shm_tests_screenshots, {

		flex: {
			grow: 1,
			basis: '40rem',
		},
		minWidth: 0,

		Body_content: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.block,
			padding: $mol_gap.block,
		},

		Summary: {
			color: $mol_theme.shade,
		},

		Screenshot: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.text,
		},

		Image: {
			width: '100%',
			height: 'auto',
		},

	} )

}
